import styled from 'styled-components';
import { COLORS } from '../../../../constants/radar';

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: ${({ $isExpanded }) => ($isExpanded ? '140px' : '48px')};
  transition: all 0.3s ease-in-out;
  position: relative;
  overflow: visible;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transform: translateY(${({ $isVisible }) => ($isVisible ? '0' : '-20px')});
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  margin-bottom: ${({ $isVisible }) => ($isVisible ? '12px' : '0')};
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  max-height: ${({ $isVisible }) => ($isVisible ? '120px' : '0')};
  z-index: 1;
`;

export const PanelContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  opacity: ${({ $isExpanded }) => ($isExpanded ? 1 : 0)};
  visibility: ${({ $isExpanded }) => ($isExpanded ? 'visible' : 'hidden')};
  transition: all 0.3s ease-in-out;
`;

export const NavigationRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-right: 40px;
  position: relative;
`;

export const ToggleContainer = styled.div`
  position: absolute;
  right: 16px;
  top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

export const ToggleButton = styled.button`
  background: transparent;
  color: ${COLORS.PRIMARY};
  border: none;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(180deg)' : 'rotate(0)')};
  transition: all 0.3s ease;
  padding: 0;
  z-index: 2;

  &:hover {
    background: ${COLORS.BACKGROUND};
  }

  svg {
    font-size: 14px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: ${COLORS.BACKGROUND};
  margin: 0 16px;
  flex-shrink: 0;
  display: block;
`;

export const Controls = styled.div`
  padding: 16px;
  position: relative;
  z-index: 2;
`;

export const CollapsedContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 48px;
  overflow: hidden;
`;

export const Label = styled.span`
  color: ${COLORS.PRIMARY};
  font-weight: 500;
  font-size: 14px;
`;

export const CollapsedPath = styled.span`
  font-size: 12px;
  color: #666;
  margin-left: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 500px;
`;

export const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
`;

export const TagSelectButton = styled.button`
  padding: 8px 16px;
  background-color: ${({ $hasSelectedTags }) => ($hasSelectedTags ? COLORS.PRIMARY : 'white')};
  color: ${({ $hasSelectedTags }) => ($hasSelectedTags ? 'white' : COLORS.PRIMARY)};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  height: 36px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: ${({ $hasSelectedTags }) => ($hasSelectedTags ? COLORS.PRIMARY_DARK : COLORS.PRIMARY)};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const TagIcon = styled.span`
  font-size: 16px;
  display: flex;
  align-items: center;
`;

export const TagCount = styled.span`
  background: ${COLORS.PRIMARY};
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
`;

export const FilterButton = styled.button`
  padding: 8px 16px;
  background-color: ${({ $isActive }) => ($isActive ? COLORS.PRIMARY : 'white')};
  color: ${({ $isActive }) => ($isActive ? 'white' : COLORS.PRIMARY)};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  height: 36px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  position: relative;
  padding-right: ${({ $isActive }) => ($isActive ? '36px' : '16px')};

  &:hover {
    background-color: ${({ $isActive }) => ($isActive ? COLORS.PRIMARY_DARK : COLORS.PRIMARY)};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:after {
    content: '';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ $isActive }) => ($isActive ? '#4CAF50' : '#666')};
    transition: all 0.2s ease;
    opacity: 1;
  }
`;

export const FilterIcon = styled.span`
  font-size: 14px;
  display: flex;
  align-items: center;
`;

export const FilterStatus = styled.span`
  font-size: 12px;
  color: ${({ $isActive }) => ($isActive ? '#4CAF50' : '#666')};
  margin-left: 8px;
  white-space: nowrap;
`;
